/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getBackOrderListAsync } from './DataActionExtension.g';
import { IGetBackOrderListResponse } from './DataServiceEntities.g';
import { QueryResultSettingsProxy, buildCacheKey /*generateCacheKey*/ } from '@msdyn365-commerce-modules/retail-actions';

/**
 * GetBackorderList Input Action
 */
export class GetBackorderListInput implements Msdyn365.IActionInput {
    public apiSettings: Msdyn365.ICommerceApiSettings;
    public accountNum: string;
    public top: number;
    public skip: number;
    public selectedSort: string;
    public sortOrder: string;

    constructor(
        context: Msdyn365.IRequestContext,
        apiSettings: Msdyn365.ICommerceApiSettings,
        top: number,
        skip: number,
        selectedSort: string,
        sortOrder: string
    ) {
        this.apiSettings = apiSettings;
        // this.accountNum = accountNum;
        this.accountNum = Msdyn365.getCustomerAccountNumberForAllChannelType(context) || '';
        this.top = top;
        this.skip = skip;
        this.selectedSort = selectedSort;
        this.sortOrder = sortOrder;
        // console.log(`selectedSort: ${selectedSort}`);
        // console.log(`sortOrder: ${sortOrder}`);
    }

    public getCacheKey = () => {
        const baseCacheKey = 'BackorderList';
        if (this.top && this.skip) {
            // return generateCacheKey(
            //     this.apiSettings,
            //     { key: 'BaseCacheKey', value: baseCacheKey },
            //     { key: 'CustomerAccountNumber', value: this.accountNum },
            //     { key: 'Top', value: this.top },
            //     { key: 'Skip', value: this.skip },
            //     { key: 'SelectedSort', value: this.selectedSort },
            //     { key: 'SortOrder', value: this.sortOrder }
            // );
            return buildCacheKey(`${baseCacheKey}-${this.top}-${this.skip}-${this.selectedSort}-${this.sortOrder}`, this.apiSettings);
        } else {
            // return generateCacheKey(
            //     this.apiSettings,
            //     { key: 'BaseCacheKey', value: baseCacheKey },
            //     { key: 'CustomerAccountNumber', value: this.accountNum }
            // );
            return buildCacheKey(`${baseCacheKey}-${this.selectedSort}-${this.sortOrder}`, this.apiSettings);
        }
    };
    public getCacheObjectType = () => 'BackorderList';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

export interface IGetBackorderListData {
    backOrderData: IGetBackOrderListResponse;
}

const createBackorderListInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const queryResultSettings = QueryResultSettingsProxy.fromInputData(args).QueryResultSettings;
    const apiSettings = args.requestContext.apiSettings;
    const context = args.requestContext;
    // @ts-expect-error
    const top = args.config?.backOrderItemsPerPage || 15;
    const skip = queryResultSettings.Paging?.Skip || 0;
    const selectedSort = args.requestContext.query?.selectedSort || 'Order Date';
    const sortOrder = args.requestContext.query?.sortOrder || 'Ascending';
    return new GetBackorderListInput(context, apiSettings, top, skip, selectedSort, sortOrder);
};

async function action(input: GetBackorderListInput, ctx: Msdyn365.IActionContext): Promise<IGetBackorderListData> {
    // console.log(`input.selectedSort: ${input.selectedSort}`);
    // console.log(`input.sortOrder: ${input.sortOrder}`);
    const response = await getBackOrderListAsync({ callerContext: ctx }, input.top, input.skip, input.selectedSort, input.sortOrder);
    return { backOrderData: response };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetBackorderListData>>action,
    id: 'GetBackorderList',
    input: createBackorderListInput
});
